<template>
  <div class="page-content users-table-view">
    <div class="container-fluid bracket-custom-style">
      <Affix :offset-top="0">
        <Card class="header-card">
          <Row>
            <Col span="16">
            <span class="page-title">{{ $t('menu.create_competition') }}</span>
            </Col>
            <Col class="d-flex justify-content-end" span="8">
            <Button class="md-checkmark-style" type="warning" @click="onCreateCompetition('competitionForm')">
              <b>{{ $t('menu.save_competition') }}</b>
            </Button>
            </Col>
          </Row>
        </Card>
      </Affix>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t('global.loading') }}</div>
      </Spin>
      <Row v-else style="margin-top: 20px;">
        <Col span="24">
        <div style="padding-bottom: 50px;">
          <Row>
            <Form ref="competitionForm" :model="formItem" :rules="ruleInline" label-position="top">
              <Col span="8">
              <Card style="max-width: 640px;">
                <FormItem :label="$t('competition.name')" prop="competitionName">
                  <Input v-model="formItem.competitionName" placeholder="Introdu denumirea competitiei"></Input>
                </FormItem>

                <FormItem :label="$t('club.table.date')" prop="date">
                  <DatePicker v-model="formItem.date" format="dd-MM-yyyy" placeholder="Select date" split-panels
                    style="width: 200px;" type="daterange"></DatePicker>
                </FormItem>

                <FormItem :label="$t('competition.category')" prop="formats">
                  <div class="d-flex justify-content-between">
                    <CheckboxGroup v-model="formItem.formats" class="d-grid justify-content-start" size="large"
                      @on-change="onSelectTeamCategories">
                      <Checkbox v-for="cat in teamCategories.filter((cat) => cat.name.includes('B'))" :key="cat._id"
                        :label="cat._id" :value="cat._id" class="category-checkbox">{{ cat.name }}
                      </Checkbox>
                    </CheckboxGroup>
                    <CheckboxGroup v-model="formItem.formats" class="d-grid justify-content-end" size="large"
                      @on-change="onSelectTeamCategories">
                      <Checkbox v-for="cat in teamCategories.filter((cat) => cat.name.includes('F'))" :key="cat._id"
                        :label="cat._id" :value="cat._id" class="category-checkbox">{{ cat.name }}
                      </Checkbox>
                    </CheckboxGroup>
                  </div>
                </FormItem>

                <FormItem :label="$t('competition.type')" prop="ttype">
                  <RadioGroup v-model="formItem.selectTtypes" class="d-flex flex-wrap justify-content-between"
                    @on-change="onSelectTtypes">
                    <Radio v-for=" ttype  in  ttypes " :key="ttype._id" :label="ttype._id" :value="ttype._id"
                      class="ttypes-radio-style">
                      {{ ttype.name }}
                    </Radio>
                  </RadioGroup>
                </FormItem>

                <FormItem :label="$t('user.responsible')">
                  <Select v-model="formItem.selectResponsibile" :placeholder="$t('user.select_responsible')"
                    @on-change="onSelectResponsible">
                    <Option value="none">{{ $t('user.responsible') }}</Option>
                    <Option v-for=" user  in  users " :key="user._id" :value="user._id">
                      {{ user.name }}
                    </Option>
                  </Select>
                </FormItem>

                <FormItem :label="$t('competition.reg_start')" prop="startRegDate">
                  <CompetitionDateHour :customKey="Date.now()" :data="startRegistered" :formItemDate="formItem.date"
                    :valueTimePicker="valueTimePicker" @onChangeDates="setStartDate('startRegistered', startRegistered)"
                    @onChangeHours="setStartHour('startRegistered', startRegistered)" />
                </FormItem>

                <FormItem :label="$t('competition.reg_end')" prop="endRegDate">
                  <CompetitionDateHour :customKey="Date.now()" :data="endRegistered" :formItemDate="formItem.date"
                    :valueTimePicker="valueTimePicker" @onChangeDates="setStartDate('endRegistered', endRegistered)"
                    @onChangeHours="setStartHour('endRegistered', endRegistered)" />
                </FormItem>
                <div class="d-flex justify-content-between align-items-center">
                  <FormItem :label="$t('competition.top_stats')" prop="enableStats">
                    <Checkbox label="stats" v-model="formItem.enableStats" class="category-checkbox"> {{ formItem.enableStats ? 'On' : 'Off' }} </Checkbox>
                  </FormItem>
                  <FormItem :label="$t('competition.late_reg')" prop="forceLateReg">
                    <Checkbox label="force_reg" v-model="formItem.forceLateReg" class="category-checkbox"> {{ formItem.forceLateReg ? 'On' : 'Off' }} </Checkbox>
                  </FormItem>
                </div>

                <!--                    <FormItem :label="$t('user.referee')">-->
                <!--                      <Select v-model="formItem.selectReferee" :placeholder="$t('user.select_referee')"-->
                <!--                              clearable filterable style="width: 425px;" @on-change="onSelectReferee">-->
                <!--                        <Option value="none">{{ $t('user.referee') }}</Option>-->
                <!--                        <Option v-for="user in referee" :key="user._id" :disabled="true" :value="user._id"-->
                <!--                                class="disabled-referee">-->
                <!--                          <div class="d-flex align-items-center justify-content-between" style="100%">-->
                <!--												<span>-->
                <!--													<b>{{ user.firstName }} {{ user.secondName }}</b>-->
                <!--												</span>-->
                <!--                            <Button :disabled="user.selectedWithCompetition" icon="md-add" type="success"-->
                <!--                                    @click="addReferee(user)"></Button>-->
                <!--                          </div>-->
                <!--                        </Option>-->
                <!--                      </Select>-->

                <!--                      <div v-if="selectedRefereeWithCompetiton.length > 0" class="mt-3">-->
                <!--                        <template v-for="(selectedReferee, index) in selectedRefereeWithCompetiton">-->
                <!--                          <div :key="selectedReferee._id" class="mb-2">-->
                <!--                            <div class="d-flex align-items-center justify-content-between"-->
                <!--                                 style="width: 425px; padding: 3px 16px;">-->
                <!--													<span>-->
                <!--														<b>{{ selectedReferee.firstName }} {{ selectedReferee.secondName }}</b>-->
                <!--													</span>-->
                <!--                              <div class="d-flex align-items-center">-->
                <!--                                <InputNumber :key="selectedReferee._id" v-model="selectedReferee.spends" :min="+0"-->
                <!--                                             :value="+0"-->
                <!--                                             placeholder="0" style="margin-right: 5px; max-width: 78px;"></InputNumber>-->
                <!--                                <span>{{$t('competition.lei')}}</span>-->
                <!--                                <Button class="ml-5" icon="md-trash" type="error"-->
                <!--                                        @click="removeReferee(selectedReferee, index)"></Button>-->
                <!--                              </div>-->
                <!--                            </div>-->
                <!--                          </div>-->
                <!--                        </template>-->
                <!--                      </div>-->
                <!--                    </FormItem>-->

                <!--                    <div class="d-flex">-->
                <!--                      <FormItem label="Ambulanta" style="width: 50%;">-->
                <!--                        <div class="d-flex align-items-center">-->
                <!--                          <Checkbox v-model="formItem.ambulance.status">Ambulanta</Checkbox>-->

                <!--                          <div v-if="formItem.ambulance.status" class="d-flex align-items-center ml-4">-->
                <!--                            <InputNumber v-model="formItem.ambulance.spends" :min="+0" :value="+0"-->
                <!--                                         placeholder="0" style="margin-right: 5px; max-width: 78px;"></InputNumber>-->
                <!--                            <span>{{$t('competition.lei')}}</span>-->
                <!--                          </div>-->
                <!--                        </div>-->
                <!--                      </FormItem>-->

                <!--                      <FormItem label="Medic" style="width: 50%;">-->
                <!--                        <div class="d-flex align-items-center">-->
                <!--                          <Checkbox v-model="formItem.medic.status">Medic</Checkbox>-->

                <!--                          <div v-if="formItem.medic.status" class="d-flex align-items-center ml-4">-->
                <!--                            <InputNumber v-model="formItem.medic.spends" :min="+0" :value="+0"-->
                <!--                                         placeholder="0" style="margin-right: 5px; max-width: 78px;"></InputNumber>-->
                <!--                            <span>{{$t('competition.lei')}}</span>-->
                <!--                          </div>-->
                <!--                        </div>-->
                <!--                      </FormItem>-->
                <!--                    </div>-->

                <FormItem class="competition-tech-pass" :label="$t('competition.regulations')">
                  <Card>
                    <div slot="title">
                      <Upload ref="upload" :action="api_domain + 'file/upload'" :before-upload="handleBeforeUpload"
                        :format="['jpg', 'jpeg', 'png', 'pdf']" :on-format-error="handleFormatError"
                        :on-remove="handleRemove" :on-success="handleSuccess" :show-upload-list="true" multiple
                        type="drag">
                        <div style="padding: 20px 0; width: 100%;">
                          <Icon size="52" style="color: #3399ff;" type="ios-cloud-upload"></Icon>
                          <p>Click or drag files here to upload</p>
                        </div>
                      </Upload>
                    </div>
                    <div v-if="uploadList && uploadList.length > 0" class="upload-file-list-block">
                      <h6 class="mb-2">{{ $t('invoice.attachment') }}</h6>
                      <a v-for="( att, key ) in  uploadList " :id="att" :href="api_domain + att"
                        class="mr-1 upload-file-list" target="_blank">
                        <i class="attachment bx bxs-file" style="font-size: 40px;"></i>
                        <i class="bx bxs-trash" style="font-size: 15px; color: red;" @click="handleRemoveUploadList"></i>
                      </a>
                    </div>
                  </Card>
                </FormItem>

                <div>
                  <Divider />
                  <FormItem :label="$t('competition.notes')">
                    <CompetitionFileTextComponent :compFileText="compFileText" :customKey="'notice'" />
                  </FormItem>
                </div>

                <div class="mb-3">
                  <div v-for="( item, idx ) in  formDynamicNotice " v-if="item.status" style="position: relative;">
                    <Divider />
                    <FormItem :key="idx" :label="'Informatie ' + (idx + 1)">
                      <Button class="d-flex align-items-center justify-content-center" icon="md-trash"
                        style="position: absolute; top: -30px; right: 0;" type="error"
                        @click="removeCustomNotice(idx)"></Button>
                      <CompetitionFileTextComponent :compFileText="item" :customKey="'information'" />
                    </FormItem>
                  </div>
                </div>

                <div>
                  <div v-for="( item, idx ) in  formDynamicRent " v-if="item.status" style="position: relative;">
                    <Divider />
                    <FormItem :key="idx" :label="'Cheltuieli ' + (idx + 1)">
                      <Button class="d-flex align-items-center justify-content-center" icon="md-trash"
                        style="position: absolute; top: -30px; right: 0;" type="error"
                        @click="removeCustomRent(idx)"></Button>
                      <CompetitionFileInputComponent :compFileText="item" :customKey="'spends'" />
                    </FormItem>
                  </div>
                </div>

                <div>
                  <Row>
                    <Col class="mb-3" span="24">
                    <Button type="success" size="large" long @click="addCustomNotice">{{ $t('competition.add_field')
                    }}</Button>
                    </Col>
                    <Col span="24">
                    <Button type="success" size="large" long @click="addCustomRent">{{ $t('competition.add_spends')
                    }}</Button>
                    </Col>
                  </Row>
                </div>
              </Card>
              </Col>
              <Col span="13" offset="1">

              <div v-if="formItem.selectTtypes" class="mb-3" style="text-align: center">
                <ButtonGroup shape="circle" size="large" style="max-width: 200px">
                  <Button type="primary" size="large" @click="() => { if (formItem.stage > 0) formItem.stage--; }"><i
                      class='bx bx-minus wtf-icon'></i> </Button>
                  <div class="etaps" size="large">{{ formItem.stage }}</div>
                  <Button type="primary" size="large" @click="() => { formItem.stage++; }"><i
                      class='bx bx-plus wtf-icon'></i> </Button>
                </ButtonGroup>
              </div>

              <!--                    <InputNumber v-model="formItem.stage" :max="maxStageNumber" :min="+0"-->
              <!--                                 placeholder="0" style="margin-right: 5px; max-width: 78px;"></InputNumber>-->
              <Row :gutter="20" type="flex" justify="center">
                <template v-for="( stage, idx ) in  stageCount ">
                  <Col>
                  <Card class="mb-3">
                    {{ $t('competition.stage') }}: {{ idx + 1 }}
                    <FormItem v-if="stageCount.length > 0" :label="$t('club.table.date')" :prop="`stageDate${idx + 1}`">
                      <CompetitionDateHour :customKey="Date.now()" :data="stage" :formItemDate="formItem.date"
                        :stageKey="'stage'" :valueTimePicker="valueTimePicker"
                        @onChangeDates="setStartDate('stage', stage, idx)"
                        @onChangeHours="setStartHour('stage', stage, idx)" />

                    </FormItem>
                    <FormItem v-if="ifTtypes && stageCount.length > 0" :label="$t('competition.field')">
                      <div class="d-flex align-items-center">
                        <Input v-model="stage.stadium" class="mr-3" placeholder="Denumirea terenului" />
                        <InputNumber v-model="stage.spends" :min="+0" :value="+0" placeholder="0"
                          style="margin-right: 5px; max-width: 78px;"></InputNumber>
                        <span>{{ $t('competition.lei') }}</span>
                      </div>
                    </FormItem>
                    <divider />
                    <FormItem :label="$t('user.referee')">
                      <Select v-model="formItem.selectReferee" :placeholder="$t('user.select_referee')" clearable
                        filterable style="width: 425px;" @on-change="onSelectReferee">
                        <Option value="none">{{ $t('user.referee') }}</Option>
                        <Option v-for=" item  in  referee " :key="item._id" :disabled="true" :value="item._id"
                          class="disabled-referee">
                          <div class="d-flex align-items-center justify-content-between" style="100%">
                            <span>
                              <b>{{ item.firstName }} {{ item.secondName }}</b>
                            </span>
                            <Button :disabled="stage.refereeInfo.findIndex(el => el._id === item._id) >= 0" icon="md-add"
                              type="success" @click="addReferee(JSON.parse(JSON.stringify(item)), idx)"></Button>
                          </div>
                        </Option>
                      </Select>

                      <div class="mt-3">
                        <template v-for="( selectedReferee, index ) in  stage.refereeInfo ">
                          <div :key="selectedReferee._id" class="mb-2">
                            <div class="d-flex align-items-center justify-content-between"
                              style="width: 425px; padding: 3px 16px;">
                              <span>
                                <b>{{ selectedReferee.firstName }} {{ selectedReferee.secondName }}</b>
                              </span>
                              <div class="d-flex align-items-center">
                                <InputNumber :key="selectedReferee._id" v-model="selectedReferee.spends" :min="+0"
                                  :value="+0" placeholder="0" style="margin-right: 5px; max-width: 78px;"></InputNumber>
                                <span>{{ $t('competition.lei') }}</span>
                                <Button class="ml-5" icon="md-trash" type="error"
                                  @click="removeReferee(selectedReferee, index, idx)"></Button>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </FormItem>

                    <divider />
                    <FormItem :label="$t('competition.spends')">
                      <Row>
                        <Col span="12" style="border-right: 1px solid #eee;padding-right: 10px;">
                        <div class="d-flex align-items-center">
                          <span style="width: 100%">{{ $t('competition.medic') }}</span>
                          <InputNumber size="small" v-model="stage.spends_medic" :min="+0" :value="+0" placeholder="0"
                            style="margin-right: 5px; max-width: 78px;"></InputNumber>
                          <span>{{ $t('competition.lei') }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <span style="width: 100%">{{ $t('competition.ambulance') }}</span>
                          <InputNumber size="small" v-model="stage.spends_ambulance" :min="+0" :value="+0" placeholder="0"
                            style="margin-right: 5px; max-width: 78px;"></InputNumber>
                          <span>{{ $t('competition.lei') }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <span style="width: 100%; line-height: 1.2;">{{ $t('competition.prize') }}</span>
                          <InputNumber size="small" v-model="stage.spends_cups" :min="+0" :value="+0" placeholder="0"
                            style="margin-right: 5px; max-width: 78px;"></InputNumber>
                          <span>{{ $t('competition.lei') }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <span style="width: 100%">{{ $t('competition.water') }}</span>
                          <InputNumber size="small" v-model="stage.spends_water" :min="+0" :value="+0" placeholder="0"
                            style="margin-right: 5px; max-width: 78px;"></InputNumber>
                          <span>{{ $t('competition.lei') }}</span>
                        </div>
                        </Col>
                        <Col span="12" class="pl-1">
                        <div class="d-flex align-items-center">
                          <span style="width: 100%">{{ $t('competition.food') }}</span>
                          <InputNumber size="small" v-model="stage.spends_food" :min="+0" :value="+0" placeholder="0"
                            style="margin-right: 5px; max-width: 78px;"></InputNumber>
                          <span>{{ $t('competition.lei') }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <span style="width: 100%">{{ $t('competition.transport') }}</span>
                          <InputNumber size="small" v-model="stage.spends_transport" :min="+0" :value="+0" placeholder="0"
                            style="margin-right: 5px; max-width: 78px;"></InputNumber>
                          <span>{{ $t('competition.lei') }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <span style="width: 100%">{{ $t('competition.others') }}... </span>
                          <InputNumber size="small" v-model="stage.spends_other" :min="+0" :value="+0" placeholder="0"
                            style="margin-right: 5px; max-width: 78px;"></InputNumber>
                          <span>{{ $t('competition.lei') }}</span>
                        </div>
                        </Col>
                      </Row>


                    </FormItem>
                  </Card>
                  </Col>
                </template>
              </Row>


              </Col>

            </Form>
          </Row>
        </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import mixin from '../mixinTable';
import CompetitionDateHour from './utils/CompetitionDateHour';
import CompetitionFileTextComponent from './utils/CompetitionFileTextComponent';
import CompetitionFileInputComponent from './utils/CompetitionFileInputComponent';

export default {
  name: 'CreateCompetition',
  components: { CompetitionDateHour, CompetitionFileTextComponent, CompetitionFileInputComponent },
  mixins: [mixin],
  data() {
    const validateDate = (rule, value, callback) => {
      const validField = value.filter((item) => item !== '');

      if (validField.length <= 0) {
        callback(new Error('Please fill in the date'));
      } else {
        return callback();
      }
    };
    const validateTtype = (rule, value, callback) => {
      value = this.ifSelectedTtype;

      if (value.length <= 0) {
        callback(new Error('Please fill in the type'));
      } else {
        callback();
      }
    };
    const validateStartRegistered = (rule, value, callback) => {
      console.log(rule, value);
      if (this.startRegistered.startDate.length <= 0) {
        callback(new Error('Please fill in the Start registered date'));
      } else if (this.startRegistered.startHour.length <= 0) {
        callback(new Error('Please fill in the Start registered hour'));
      } else {
        callback();
      }
    };
    const validateEndRegistered = (rule, value, callback) => {
      if (this.endRegistered.startDate.length <= 0) {
        callback(new Error('Please fill in the End registered date'));
      } else if (this.endRegistered.startHour.length <= 0) {
        callback(new Error('Please fill in the End registered hour'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      ifTtypes: false,
      uploadList: null,
      errorFile: null,
      formItem: {
        competitionName: '',
        selectTtypes: '',
        selectResponsibile: null,
        selectReferee: [],
        formats: [],
        date: [],
        stage: 0,
        enableStats: false,
        forceLateReg: false,
        // refereePrice: 0,
        // medic: {
        //   status: false,
        //   spends: 0,
        // },
        // ambulance: {
        //   status: false,
        //   spends: 0,
        // },
        regulations: [],
      },
      teamCategories: [],
      ttypes: [],
      ifSelectedTtype: '',
      users: [],
      referee: [],
      selectedRefereeWithCompetiton: [],
      valueTimePicker: ['Hour', 'Minutes'],
      stageCount: [],
      hourDisabled: true,
      startRegistered: {
        startDate: '',
        startHour: '',
      },
      endRegistered: {
        startDate: '',
        startHour: '',
      },
      index: 0,
      formDynamicNotice: [],
      formDynamicRent: [],
      compFileText: {
        noticeUploadList: [],
        imgName: '',
        visibleNoticeModal: false,
        valueNotice: '',
      },
      aditionalInfo: {
        noticeUploadList: [],
        imgName: '',
        visibleNoticeModal: false,
        valueNotice: '',
      },
      aditionalSpents: {
        rentUploadList: [],
        imgName: '',
        visibleRentModal: false,
        valueRent: '',
      },
      maxStageNumber: 38,
      ruleInline: {
        competitionName: [{ required: true, message: 'Please fill in the Competition name', trigger: 'blur' }],
        date: [{ required: true, validator: validateDate, trigger: 'blur' }],
        formats: [{
          required: true,
          type: 'array',
          min: 1,
          message: 'Please choose at least one formats',
          trigger: 'change'
        }],
        ttype: [{ required: true, validator: validateTtype, trigger: 'change' }],
        startRegDate: [{ required: true, validator: validateStartRegistered, trigger: 'change' }],
        endRegDate: [{ required: true, validator: validateEndRegistered, trigger: 'change' }],
      },
    };
  },
  watch: {
    formItem: {
      deep: true,
      handler(_n) {
        this.changes = true
      }
    },
    changes(n) {
      console.log("change", n);
    },
    'formItem.stage'(n, o) {
      if (n > this.maxStageNumber) {
        this.formItem.stage = this.maxStageNumber
      }

      if (n > o) {
        this.ruleInline['stageDate' + (parseInt(n))] = [{ required: true, validator: this.specialValidateStartRegistered, trigger: 'change' }]
        console.log(this.ruleInline);
        let int = n - o;
        let stageDateObj = {
          name: '',
          date_start: '',
          date_end: '',
          stadium: '',
          spends: 0,
          isCurrent: false,
          refereeInfo: [],
          spends_medic: 0,
          spends_ambulance: 0,
          spends_cups: 0,
          spends_water: 0,
          spends_food: 0,
          spends_transport: 0,
          spends_other: 0,
        };

        for (let i = 0; i < int; i++) {
          this.stageCount.push({ ...stageDateObj });
        }

        for (let j = 0; j < this.stageCount.length; j++) {
          this.stageCount[j].name = 'Etapa ' + (j + 1)
        }
      } else {
        let int = o - n;
        for (let i = 0; i < int; i++) {
          this.stageCount.pop();
        }
      }
    },
    // 'formItem.ambulance.status'(value) {
    //   if (value === false) {
    //     this.formItem.ambulance.spends = 0;
    //   }
    // },
    // 'formItem.medic.status'(value) {
    //   if (value === false) {
    //     this.formItem.medic.spends = 0;
    //   }
    // },
    // 'startRegistered.startDate'(n, o) {
    // 	console.log('startRegistered startDate', n, o);
    // },
    // 'startRegistered.startHour'(n, o) {
    // 	console.log('startRegistered startHour', n, o);
    // },
    // stageCount() {
    // 	console.log('stageCount', this.stageCount);
    // },
  },
  methods: {
    specialValidateStartRegistered(rule, value, callback) {
      console.log(rule.field.slice(-1));
      if (this.stageCount[parseInt(rule.field.slice(-1)) - 1].date_start) {
        callback();
      } else {
        callback(new Error('Please fill in the Start registered hour'));
      }
    },
    removeCustomNotice(index) {
      this.index--;
      this.formDynamicNotice[index].status = 0;
      this.formDynamicNotice[index].index = this.index;
    },
    addCustomNotice() {
      this.index++;
      this.formDynamicNotice.push({
        value: '',
        index: this.index,
        status: 1,
        ...this.aditionalInfo,
      });
    },
    removeCustomRent(index) {
      this.index--;
      this.formDynamicRent[index].status = 0;
      this.formDynamicRent[index].index = this.index;
    },
    addCustomRent() {
      this.index++;
      this.formDynamicRent.push({
        value: '',
        index: this.index,
        status: 1,
        ...this.aditionalSpents,
      });
    },
    handleBeforeUpload() {
      this.errorFile = null;
      return true;
    },
    handleFormatError(error, file, fileList) {
      this.errorFile = {
        file,
        fileList,
      };
      this.$Notice.warning({
        title: file,
        desc: 'File format of ' + fileList.name + ' is incorrect, please select jpg, png or pdf',
      });
    },
    handleRemove(res, file) {
      this.formItem.regulations.splice(res, 1);
    },
    handleSuccess(res, file) {
      this.formItem.regulations.push(res.path);
    },
    handleRemoveUploadList(res, file) {
      res.preventDefault();
      this.formItem.regulations.splice(res, 1);
      this.uploadList.splice(res, 1);
    },
    removeReferee(user, index, idx) {
      user.selectedWithCompetition = -1;
      this.stageCount[idx].refereeInfo.splice(index, 1);
    },
    addReferee(user, idx) {
      user.selectedWithCompetition = idx;
      this.stageCount[idx].refereeInfo.push(user);
    },
    onCreateCompetition(name) {
      console.log('Click onCreateCompetition');

      const {
        competitionName,
        selectTtypes,
        selectResponsibile,
        // selectReferee,
        formats,
        date,
        stage,
        // refereePrice,
        stadiumName,
        stadiumRent,
        enableStats,
        forceLateReg,
        // medic,
        // ambulance,
        regulations,
        ...other
      } = this.formItem;

      let stageDateObj = {
        name: 'Etapa 1',
        date_start: new Date(),
        date_end: '',
        stadium: '',
        spends: '',
        isCurrent: true,
        refereeInfo: [],
        spends_medic: 0,
        spends_ambulance: 0,
        spends_cups: 0,
        spends_water: 0,
        spends_food: 0,
        spends_transport: 0,
        spends_other: 0,
      };

      let responsible;

      if (selectResponsibile === 'none' || selectResponsibile === '') {
        responsible = null;
      } else {
        responsible = selectResponsibile;
      }
      let tempStages = [];
      this.stageCount.forEach((item) => {
        let arr = item.refereeInfo.map((item) => {
          return {
            referee: item._id,
            spends: item.spends,
          };
        })
        item.refereeInfo = arr;

        tempStages.push(JSON.parse(JSON.stringify(item)))
      })

      const competition = {
        name: competitionName,
        date: date,
        formats: formats.map(item => {
          return {
            category: item
          }
        }),
        ttype: selectTtypes,
        responsible: responsible,
        enableStats: enableStats,
        forceLateReg: forceLateReg,
        stages: this.stageCount.length > 0 ? tempStages : [stageDateObj],
        reg_date: [this.startRegistered.startDate, this.endRegistered.startDate],
        // ambulance: {
        //   status: ambulance.status,
        //   spends: ambulance.spends,
        // },
        // medic: {
        //   status: medic.status,
        //   spends: medic.spends,
        // },
        regulations: regulations,
        notes: {
          text: this.compFileText.valueNotice,
          files: this.compFileText.noticeUploadList,
        },

        additional_info: this.formDynamicNotice.map((item) => {
          return {
            text: item.valueNotice,
            files: item.noticeUploadList,
          };
        }),
        additional_spends: this.formDynamicRent.map((item) => {
          return {
            text: item.valueRent,
            files: item.rentUploadList,
            spends: item.priceRent,
          };
        }),
      };

      console.log('competition', competition);
      console.log("ruleInline", this.ruleInline);
      console.log(this.$refs);
      // console.log(competition)
      // return;
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.loading = true;
          this.onAddNewCompetition(competition);
        } else {
          this.$Message.error(this.$t('global.error'));
        }
      });
    },
    onSelectTtypes(value) {
      this.ifSelectedTtype = value;
      const selectTtypes = this.ttypes.find((item) => item._id === value);

      if (selectTtypes.name.includes('12') || selectTtypes.name.includes('15')) {
        this.ifTtypes = false;
      } else {
        this.ifTtypes = true;
      }
      this.formItem.stage = 0;
    },
    onSelectTeamCategories(value) {
      console.log('onSelectTeamCategories', value);
    },
    onSelectResponsible(value) {
      console.log('onSelectResponsible', value);
    },
    onSelectReferee(value) {
      console.log('onSelectReferee', value);
    },
    setStartDate(key, stage, index) {
      if (key === 'stage') {
        if (stage.startDate) {
          if (!this.endRegistered.startDate) {
            const dates1 = new Date(stage.startDate);
            const dates2 = new Date(dates1.setDate(dates1.getDate() - 1));
            this.endRegistered.startDate = dates2;
          }
        }
        this.stageCount[index].date_start = stage.startDate;
      }
    },
    setStartHour(key, stage, index) {
      if (stage) {
        const hours = stage.startHour.split(':');
        if (stage.startDate) {
          stage.startDate.setHours(hours[0], hours[1]);
        }

        if (key === 'stage' && index === 0) {
          this.endRegistered.startDate.setHours(hours[0], hours[1]);
          this.endRegistered.startHour = stage.startHour;
        }
      }
    },
    async onAddNewCompetition(competition) {
      console.log(this.ruleInline);
      try {
        await this.$http.post('/competition/addNew', competition).then((response) => {
          console.log('response', response);
          this.loading = true;

          this.$Message.success({
            content: this.$t('global.saved'),
            duration: 2,
          });

          this.clearForm();

          setTimeout(() => {
            this.loading = false;
            this.changes = false
          }, 2000);
        });
      } catch (err) {
        this.$Message.error({
          content: this.$t('global.error'),
          duration: 2,
        });
        setTimeout(() => {
          this.loading = false;
        }, 2000);
        console.log('Error', 'Something Went Wrong', err.response);
      }
    },
    async getTeamCategories() {
      try {
        await this.$http
          .post('/competition/category/list')
          .then((response) => {
            this.teamCategories = response.data;
          })
          .catch((error) => console.log('Error getTeamCategories', error));
      } catch (err) {
        console.log('Error', 'Something Went Wrong', err.response);
      }
    },
    async getTtypes() {
      try {
        await this.$http
          .post('/competition/ttype/list')
          .then((response) => {
            this.ttypes = response.data.sort((a, b) => a.sort_count - b.sort_count);
          })
          .catch((error) => console.log('Error getTeamCategories', error));
      } catch (err) {
        console.log('Error', 'Something Went Wrong', err.response);
      }
    },
    async getUsers() {
      try {
        await this.$http
          .get('/user')
          .then((response) => {
            this.users = response.data.users;
          })
          .catch((error) => console.log('Error getTeamCategories', error));
      } catch (err) {
        console.log('Error', 'Something Went Wrong', err.response);
      }
    },
    async getReferee() {
      const refereeId = ['642d3502a76384148ef547ea', '642d34faa76384148ef547e5', '642d34f2a76384148ef547df'];
      try {
        await this.$http
          .post('/license/list', { categoryId: refereeId })
          .then((response) => {
            const resp = response.data;

            resp.forEach((item) => {
              let items = { ...item };
              items.selectedWithCompetition = -1;
              items.spends = 0;
              this.referee.push(items);
            });
          })
          .catch((error) => console.log('Error getTeamCategories', error));
      } catch (err) {
        console.log('Error', 'Something Went Wrong', err.response);
      }
    },
    clearForm() {
      this.$refs.competitionForm.resetFields();

      this.startRegistered.startDate = '';
      this.startRegistered.startHour = '';
      this.endRegistered.startDate = '';
      this.endRegistered.startHour = '';
      // this.ttypes = [];
      this.formItem.selectResponsibile = null;
      this.formItem.selectTtypes = '';
      // this.formItem.selectReferee = [];
      this.formItem.stage = 0;
      // this.formItem.medic.status = false;
      // this.formItem.medic.spends = 0;
      // this.formItem.ambulance.status = false;
      // this.formItem.ambulance.spends = 0;
      this.compFileText.noticeUploadList = [];
      this.compFileTextimgName = '';
      this.compFileTextvalueNotice = '';
      this.selectedRefereeWithCompetiton = [];
      this.changes = false
    },
    // leaving(e) {
    // 	e.preventDefault()
    // 	window.removeEventListener('beforeunload', this.leaving)
    // 	if (this.changes === true) {
    // 		this.$dialog
    // 			.confirm(
    // 				this.$t('global.nonSaveConfirm'),
    // 				{
    // 					okText: this.$t("global.yes"),
    // 					cancelText: this.$t("global.no"),
    // 					html: true,
    // 					customClass: "dialog-custom edit-truck-driver-modal",
    // 				}
    // 			).then(async (_dialog) => {
    // 				e.returnValue = true
    // 			}).catch((_error) => {
    // 				e.returnValue = false
    // 			});
    // 	} else { e.returnValue = true }
    // },
  },
  // beforeDestroy() {
  // 	window.removeEventListener('beforeunload', this.leaving);
  // },
  beforeRouteLeave(_to, _from, next) {
    if (this.changes === true) {
      this.$dialog
        .confirm(
          this.$t('global.nonSaveConfirm'),
          {
            okText: this.$t("global.yes"),
            cancelText: this.$t("global.no"),
            html: true,
            customClass: 'mahnung-confirm',
          }
        ).then(async (_dialog) => {
          next();
        }).catch((_error) => {
          next(false);
        });
    } else {
      next();
    }
  },
  mounted: async function () {
    await this.getTeamCategories();
    await this.getTtypes();
    await this.getUsers();
    await this.getReferee();
    setTimeout(() => {
      this.changes = false
    }, 0)
  },
  // created() {
  // 	window.addEventListener("beforeunload", this.leaving);
  // },
};
</script>
<style scoped>
.competition-tech-pass :global(.ivu-form-item-content .ivu-upload) {
  width: 100%;
}

.bracket-custom-style .ivu-spin {
  background: #454751 !important;
  color: #ffffff;
  z-index: 999;
}

.upload-file-list {
  position: relative;
  display: inline-block;
}

.users-table-view .header-card {
  background: var(--bg-darkness);
  color: var(--text-color);
}

.users-table-view .page-title {
  font-size: 24px;
  font-weight: 600;
}

.upload-file-list .bxs-trash {
  position: absolute;
  top: -5px;
  right: -2px;
  display: none;
  opacity: 0.8;
}

.upload-file-list .bxs-trash:hover {
  opacity: 1;
}

.upload-file-list:hover .bxs-trash {
  display: inline-block;
}

.competition-tech-pass :global(.ivu-card-head) {
  border-bottom: none;
}

.competition-tech-pass :global(.ivu-card-body) {
  padding: 0;
}

.upload-file-list-block {
  padding: 16px;
  border-top: 1px solid #e8eaec;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file) {
  display: flex;
  align-items: center;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file > span) {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 244px;
  position: relative;
  padding-left: 17px;
  display: block;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file > span > i) {
  position: absolute;
  left: 0;
}

.competition-tech-pass :global(.ivu-upload-list .ivu-upload-list-file) {
  justify-content: space-between !important;
}

.disabled-referee.ivu-select-item-disabled {
  cursor: default !important;
}

.disabled-referee.ivu-select-item-disabled:hover {
  background: #f3f3f3 !important;
}

.disabled-referee.ivu-select-item-disabled span>b {
  color: #515a6e !important;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.ttypes-radio-style.ivu-radio-wrapper,
.category-checkbox {
  margin: 0 4px 8px 4px;
  width: 75px;
  height: 50px;
  padding: 5px;
  background: #f3f3f3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  font-size: 13px;
}

.ttypes-radio-style:hover,
.category-checkbox:hover {
  background: #e4e4e4;
}

.ttypes-radio-style.ivu-radio-wrapper {
  text-wrap: wrap;
  line-height: 1;
  text-align: center;
}

.ttypes-radio-style :global(.ivu-radio),
.category-checkbox :global(.ivu-checkbox) {
  display: none !important;
  position: absolute;
  top: -25px;
  left: -25px;
  transform: rotate(45deg);
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner),
.category-checkbox :global(.ivu-checkbox .ivu-checkbox-inner) {
  border-radius: 0;
  width: 42px;
  height: 42px;
  background: #5ABB73;
  border-color: #5ABB73;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after),
.category-checkbox :global(.ivu-checkbox .ivu-checkbox-inner:after) {
  top: auto;
  left: auto;
  bottom: 15px;
  right: 2px;
  transform: rotate(0deg);
  width: 7px;
  height: 13px;
  border: 3px solid #ffffff;
  border-top: 0;
  border-left: 0;
}

.ttypes-radio-style :global(.ivu-radio .ivu-radio-inner:after) {
  border-radius: 0;
  background: none;
}

.ttypes-radio-style.ivu-radio-wrapper-checked,
.category-checkbox.ivu-checkbox-wrapper-checked {
  border: 3px solid #5ABB73;
}

.ttypes-radio-style.ivu-radio-wrapper-checked :global(.ivu-radio),
.category-checkbox.ivu-checkbox-wrapper-checked :global(.ivu-checkbox) {
  display: inline-block !important;
}

.wtf-icon {
  font-size: 20px;
  padding-top: 1px;
}

.d-grid {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  max-width: 280px;
}

.etaps {
  background: white;
  position: relative;
  float: left;
  width: 50px;
  height: 35px;
  display: flex;
  text-align: center;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/CreateCompetition.vue